import { Typography } from '@mui/material';
import React, { Fragment } from 'react';

const { useState, useEffect, useRef } = React;
import estilos from './Documentacion.module.css';



const FormularioDocumentacion = (props) => {
    const data = props.data
    //DATOS PARA GENERAR DOCUMENTACIÓN DE CONTRATOS
    const [numeroDeCliente, setNumeroDeCliente] = useState(data?.numerosocio);
    const [datosDelActa, setdatosDelActa] = useState('');
    const [objetoSocial, setObjetoSocial] = useState('');
    const [tipoDeIdentificacion, setTipoDeIdentificacion] = useState('');
    const [otroTipoDeIdentificacion, setOtroTipoDeIdentificacion] = useState('');
    const [numeroDeIdentificacion, setNumeroDeIdentificacion] = useState('');
    const [emisionDeAcreditacion, setEmisionDeAcreditacion] = useState('');
    const [expedidoPor, setExpedidoPor] = useState('');
    const [passwordNom, setPasswordNom] = useState('');
    const [numeroSolicitud, setNumeroSolicitud] = useState('');
    const [numCertificadoNOM, setNumCertificadoNOM] = useState('');
    const [numeroTraslado, setNumeroTraslado] = useState('');
    const [otrosServicios, setOtrosServicios] = useState('');
    const [fechaInspeccion, setFechaInspeccion] = useState('');
    const [numeroPlanEvaluacion, setNumeroPlanEvaluacion] = useState('');
    const [inspectorAsignado, setInspectorAsignado] = useState('');
    const [credencialInspector, setCredencialInspector] = useState('');
    const [telefonoInspector, setTelefonoInspector] = useState('');

   
    const botonAceptar = () => {
        let numCliente = numeroDeCliente
        if (data.personafisica == true) {
            const data = {
                numeroDeCliente: numCliente, tipoDeIdentificacion, numeroDeIdentificacion, otroTipoDeIdentificacion, emisionDeAcreditacion,
                numeroSolicitud, numCertificadoNOM, numeroTraslado, otrosServicios, fechaInspeccion, numeroPlanEvaluacion,
                inspectorAsignado, credencialInspector, telefonoInspector,
            }
            props.functionAcept(data)
        } else {
            const data = {
                numeroDeCliente: numCliente, tipoDeIdentificacion, numeroDeIdentificacion, datosDelActa, objetoSocial, otroTipoDeIdentificacion, emisionDeAcreditacion,
                numeroSolicitud, numCertificadoNOM, numeroTraslado, otrosServicios, fechaInspeccion, numeroPlanEvaluacion,
                inspectorAsignado, credencialInspector, telefonoInspector,
            }
            props.functionAcept(data)
        }
    }

    return (
        <Fragment>
            {data?.personafisica == true ?
                <Fragment>
                    <div className="form-floating mb-3">
                        <input type="text" id="floatingInput" className={`form-control`}
                            onChange={e => setNumeroDeCliente(e.target.value)}
                            value={numeroDeCliente}
                            placeholder='Número de Asociado' />
                        <label className="floatingInput">Número de Asociado</label>
                    </div>
                    <hr />
                    <h6 className='text-center'>SOLICITUD DE SERVICIOS DE INSPECCIÓN</h6>
                    <div className='row justify-content-start mb-2 text-center'>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <div className="form-floating mb-3">
                                <input type="text" id="floatingInput" className={`form-control`}
                                    onChange={e => setNumeroSolicitud(e.target.value)}
                                    value={numeroSolicitud}
                                    placeholder='No. de solicitud' />
                                <label className="floatingInput">No. de solicitud</label>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <div className="form-floating mb-3">
                                <input type="text" id="floatingInput" className={`form-control`}
                                    onChange={e => setOtrosServicios(e.target.value)}
                                    value={otrosServicios}
                                    placeholder='Otros servicios' />
                                <label className="floatingInput">Otros servicios</label>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <div className="form-floating mb-3">
                                <input type="text" className={`form-control`}
                                    onChange={e => setFechaInspeccion(e.target.value)}
                                    value={fechaInspeccion}
                                    placeholder='Fecha de inspección' />
                                <label className="floatingInput">Fecha de inspección</label>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <h6 className='text-center'>PLAN DE EVALUACIÓN</h6>
                    <div className='row justify-content-start mb-2 text-center'>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <div className="form-floating mb-3">
                                <input type="text" id="floatingInput" className={`form-control`}
                                    onChange={e => setNumeroPlanEvaluacion(e.target.value)}
                                    value={numeroPlanEvaluacion}
                                    placeholder='No. Plan de evaluación' />
                                <label className="floatingInput">No. del plan de evaluación</label>
                            </div>

                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <div className="form-floating mb-3">
                                <input type="text" id="floatingInput" className={`form-control`}
                                    onChange={e => setInspectorAsignado(e.target.value)}
                                    value={inspectorAsignado}
                                    placeholder='No. Certificado NOM vigente' />
                                <label className="floatingInput">Inspector asignado</label>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <div className="form-floating mb-3">
                                <input type="text" id="floatingInput" className={`form-control`}
                                    onChange={e => setCredencialInspector(e.target.value)}
                                    value={credencialInspector}
                                    placeholder='Número de traslado' />
                                <label className="floatingInput">Credencial del inspector</label>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <div className="form-floating mb-3">
                                <input type="text" id="floatingInput" className={`form-control`}
                                    onChange={e => setTelefonoInspector(e.target.value)}
                                    value={telefonoInspector}
                                    placeholder='Teléfono del inspector' />
                                <label className="floatingInput">Teléfono del inspector</label>
                            </div>
                        </div>
                    </div>
                </Fragment>
                :
                <Fragment>
                    <div className="form-floating mb-3">
                        <input type="text" id="floatingInput" className={`form-control`}
                            onChange={e => setNumeroDeCliente(e.target.value)}
                            value={numeroDeCliente}
                            placeholder='Número de Asociado' />
                        <label className="floatingInput">Número de Asociado</label>
                    </div>
                    <hr />
                    <h6 className='text-center'>SOLICITUD DE SERVICIOS DE INSPECCIÓN</h6>
                    <div className='row justify-content-start mb-2 text-center'>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <div className="form-floating mb-3">
                                <input type="text" id="floatingInput" className={`form-control`}
                                    onChange={e => setNumeroSolicitud(e.target.value)}
                                    value={numeroSolicitud}
                                    placeholder='No. de solicitud' />
                                <label className="floatingInput">No. de solicitud</label>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <div className="form-floating mb-3">
                                <input type="text" id="floatingInput" className={`form-control`}
                                    onChange={e => setOtrosServicios(e.target.value)}
                                    value={otrosServicios}
                                    placeholder='Otros servicios' />
                                <label className="floatingInput">Otros servicios</label>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <div className="form-floating mb-3">
                                <input type="text" className={`form-control`}
                                    onChange={e => setFechaInspeccion(e.target.value)}
                                    value={fechaInspeccion}
                                    placeholder='Fecha de inspección' />
                                <label className="floatingInput">Fecha de inspección</label>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <h6 className='text-center'>PLAN DE EVALUACIÓN</h6>
                    <div className='row justify-content-start mb-2 text-center'>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <div className="form-floating mb-3">
                                <input type="text" id="floatingInput" className={`form-control`}
                                    onChange={e => setNumeroPlanEvaluacion(e.target.value)}
                                    value={numeroPlanEvaluacion}
                                    placeholder='No. Plan de evaluación' />
                                <label className="floatingInput">No. del plan de evaluación</label>
                            </div>

                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <div className="form-floating mb-3">
                                <input type="text" id="floatingInput" className={`form-control`}
                                    onChange={e => setInspectorAsignado(e.target.value)}
                                    value={inspectorAsignado}
                                    placeholder='No. Certificado NOM vigente' />
                                <label className="floatingInput">Inspector asignado</label>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <div className="form-floating mb-3">
                                <input type="text" id="floatingInput" className={`form-control`}
                                    onChange={e => setCredencialInspector(e.target.value)}
                                    value={credencialInspector}
                                    placeholder='Número de traslado' />
                                <label className="floatingInput">Credencial del inspector</label>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <div className="form-floating mb-3">
                                <input type="text" id="floatingInput" className={`form-control`}
                                    onChange={e => setTelefonoInspector(e.target.value)}
                                    value={telefonoInspector}
                                    placeholder='Teléfono del inspector' />
                                <label className="floatingInput">Teléfono del inspector</label>
                            </div>
                        </div>
                    </div>
                </Fragment>
            }
            <div className='row'>
                <button className='btn btn-success' onClick={() => botonAceptar()}>CONTINUAR</button>
            </div>
        </Fragment>
    );
};

export default FormularioDocumentacion;
